export const QUERY_KEY = {
  list: 'list',
}

export const ALLOW_EMAIL = [
  'hj.ahn@capbox.kr',
  'fastshalny@gmail.com',
  'hyunse.oh@gmail.com',
]
